import "./styles/fonts/_fonts.scss";
import "./App.module.scss";
import { AppRoutes } from "./routes/AppRoutes";
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 100,
});

export const App = () => {
  return <AppRoutes />;
};
